import Layout from '@/views/Layout'
import linkList from '@/views/link/index'
import productsPromotedList from '@/views/link/products'
import orderList from '@/views/order/trial'
import level0orderList from '@/views/order/level0'
import thirdPartyorderList from '@/views/order/thirdParty'
import thirdOrderUpload from '@/views/order/thirdOrderUpload'
import thirdPartyTrial from '@/views/order/thirdPartyTrial'
import AIOutboundCall from '@/views/order/AIOutboundCall'
import memberList from '@/views/member/index'
import termOrgList from '@/views/termOrg/org'
import timeOrgList from '@/views/timeOrg/org'
import errorPage from '@/views/error-page/404'
import timeStaffList from '@/views/timeOrg/staff'
import promotionList from '@/views/position/index'
import thirdPartyPromotionList from '@/views/position/thirdParty'
import termChannelList from '@/views/termOrg/channel'
import timeChannelList from '@/views/timeOrg/channel'
import timeOrderList from '@/views/timeOrg/order'
import officialOrderList from '@/views/order/official'
import fullLink from '@/views/b2cStatement/fullLink'
import realTimeData from '@/views/b2cStatement/realTimeData'

import { isThirdParty, isCampus } from '@/utils/auth'

export const asyncRoutes = [
  {
    name: 'b2cStatement',
    path: '/b2c-statement',
    component: Layout,
    redirect: '/b2c-statement/school',
    meta: {
      title: isCampus() ? '校园合作项目报表' : 'B2C报表',
      icon: 'icon-chart'
    },
    children: [
      {
        path: 'fullLink',
        component: fullLink,
        meta: {
          title: '全链路报表',
          codes: ['B2C_PWcourse_Data']
        }
      },
      {
        path: 'realTimeData',
        component: realTimeData,
        meta: {
          title: '公益课实时数据',
          codes: ['B2C_PWcourse_Data']
        }
      }
    ]
  },
  {
    name: 'orderList',
    path: '/order',
    component: Layout,
    redirect: '/order/official',
    meta: {
      title: '订单中心',
      icon: 'icon-order'
    },
    children: [
      {
        path: 'level0',
        component: level0orderList,
        meta: {
          title: 'L0订单',
          codes: ['showQuarter']
        }
      },
      {
        path: 'trial',
        component: isThirdParty() ? thirdPartyTrial : orderList,
        meta: {
          title: `体验课订单${isThirdParty() ? '（店铺）' : ''}`,
          codes: ['order']
        }
      },
      {
        path: 'official',
        component: officialOrderList,
        meta: {
          title: '精品课订单',
          codes: ['official']
        }
      },
      {
        path: 'thirdParty',
        component: thirdPartyorderList,
        meta: {
          title: '店铺订单',
          codes: ['thirdPartyOrder']
        }
      },
      {
        path: 'thirdOrderUpload',
        component: thirdOrderUpload,
        meta: {
          title: '三方订单上传',
          codes: ['thirdOrderUpload']
        }
      },
      {
        path: 'AIOutboundCall',
        component: AIOutboundCall,
        meta: {
          title: 'AI外呼订单',
          codes: ['aiImport']
        }
      },
    ]
  },
  {
    name: 'linkList',
    path: '/link',
    component: Layout,
    redirect: '/link/list',
    meta: {
      title: '推广链接',
      icon: 'icon-link'
    },
    children: [
      {
        path: 'list',
        component: isThirdParty() ? productsPromotedList : linkList,
        meta: {
          title: isThirdParty() ? '推广商品' : '推广链接',
          codes: ['links']
        }
      }
    ]
  },
  {
    name: 'promotionList',
    path: '/position',
    component: Layout,
    redirect: '/position/list',
    meta: {
      title: '推广位',
      icon: 'icon-ads'
    },
    children: [
      {
        path: 'list',
        component: isThirdParty() ? thirdPartyPromotionList : promotionList,
        meta: {
          title: isThirdParty() ? '达人管理' : '推广位',
          codes: ['promotion']
        }
      }
    ]
  },
  // {
  //   name: 'promotionRecord',
  //   path: '/promotion-record',
  //   component: Layout,
  //   redirect: '/promotionRecord/list',
  //   meta: {
  //     title: '推送记录',
  //     icon: 'icon-ads'
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       component: promotionRecord,
  //       meta: {
  //         title: '推送记录',
  //         codes: ['sms']
  //       }
  //     }
  //   ]
  // },
  {
    name: 'termOrgList',
    path: '/term-report',
    component: Layout,
    redirect: '/term-report/org',
    meta: {
      title: '学期维度报表',
      icon: 'icon-table'
    },
    children: [
      {
        path: 'org',
        component: termOrgList,
        meta: {
          title: '团队报表(公益课)',
          codes: ['org']
        }
      },
      {
        path: 'channel',
        component: termChannelList,
        meta: {
          title: '推广渠道报表(公益课)',
          codes: ['channel']
        }
      }
    ]
  },
  {
    name: 'timeOrgList',
    path: '/time-report',
    component: Layout,
    redirect: '/time-report/org',
    meta: {
      title: '时间维度报表',
      icon: 'icon-chart'
    },
    children: [
      {
        path: 'order',
        component: timeOrderList,
        meta: {
          title: '订单维度',
          codes: ['timeOrder']
        }
      },
      {
        path: 'org',
        component: timeOrgList,
        meta: {
          title: '团队报表',
          codes: ['timeOrg']
        }
      },
      {
        path: 'staff',
        component: timeStaffList,
        meta: {
          title: isThirdParty() ? '达人报表' : '成员报表',
          codes: ['timeStaff']
        }
      },
      {
        path: 'link',
        component: timeChannelList,
        meta: {
          title: '推广链接报表',
          codes: ['timeChannel']
        }
      }
    ]
  },
  {
    name: 'memberList',
    path: '/staff',
    component: Layout,
    redirect: '/staff/list',
    meta: {
      title: '成员管理',
      icon: 'icon-team'
    },
    children: [
      {
        path: 'list',
        component: memberList,
        meta: {
          title: '成员管理',
          codes: ['member']
        }
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: errorPage,
    hidden: true
  }
]
